import { apiClient } from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';

export const deleteBookingRequest = async (bookingId: string) => {
  return await apiClient.delete(`${ENDPOINTS.BOOKINGS}/${bookingId}`);
};
